import React, { useEffect } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import useSidebar from "../../hooks/useSidebar";
import SidebarFooter from "./SidebarFooter";
import SidebarNav from "./SidebarNav";
import { useLocation } from "react-router-dom";
import Dashboard from "../../layouts/Dashboard";
import logo from "../../assets/img/logo-white.png";

const Sidebar = ({ items, showFooter = true }) => {
  const { isOpen, hideFromDisplay, setHideFromDisplay } = useSidebar();
  const router = useLocation();
  const pathName = router.pathname;

  useEffect(() => {
    hideFromDisplay && setHideFromDisplay(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName]);

  return (
    <nav
      className={`sidebar ${!isOpen ? "collapsed" : ""} 
      ${hideFromDisplay ? "d-none" : ""}`}
    >
      <div className="sidebar-content">
        <PerfectScrollbar>
          <a className="sidebar-brand d-flex" href="/">
            <div className="d-flex justify-content-center align-items-center">
              <img width="45px" className="me-1" src={logo} alt="Logo" />{" "}
            </div>
            <span className="align-middle me-3">
              {/* Delta Iut Admission Guidelines */}
              Student Panel
            </span>
          </a>

          <SidebarNav items={items} />
          {!!showFooter && <SidebarFooter />}
        </PerfectScrollbar>
      </div>
    </nav>
  );
};

export default Sidebar;
